/* eslint-disable prefer-spread */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-extend-native */
/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-rest-params */
// eslint-disable-next-line no-global-assign
Date = function (Date) {
  MyDate.prototype = Date.prototype
  return MyDate
  function MyDate () {
    if (arguments.length === 1) {
      let arg = arguments[0]
      if (typeof arg=='string') {
        let str = arg.replace(/-/g, "/")
        if (arg.indexOf("T")!==-1) {
          str = str.replace("T"," ")  
          str = str.split(".000+")[0]
        }
        arg = str
      }
      arguments[0] = arg
    }
    const bind = Function.bind
    const unbind = bind.bind(bind)
    return new (unbind(Date, null).apply(null, arguments))
  }
}(Date)
Date.now = ()=>{
  return (new Date()).getTime()
}
Date.prototype.format = function (fmt) {
  const o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()  }`).substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp(`(${  k  })`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${  o[k]}`).substr((`${  o[k]}`).length)))
    }
  }
  return fmt
}
